import React, { Component } from "react";
import "./css/memberSection.css";

// const members=[
//     {
//         "name":"abc",
//         "post":"Head",
//         "imgLocation":"..img/members/ddsd"
//     },
// ]
// post, name, imgLocation
var imgPF = "./img/members/pre_final/";
var imgF = "./img/members/final_year/";

// if (window.innerWidth > 800)
// {
//     var styleImg={
//         img:{
//             left:'-3.5vw',
//         }
//     }
//     console.log("^^^^^^^");
// }

export default class cellsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgHeight: 255,
      imgWidth: 275,
      members: [
        {
          name: "ANISH KALITA",
          post: "CONVENER & HEAD",
          imgLocation: imgF + "ANISH_KALITA.jpg",
        },
        {
          name: "RISHIKESH SHAW",
          post: "GENERAL SECRETARY",
          imgLocation: imgF + "RISHIKESH_SHAW.png",
        },
        {
          name: "ANIRUDH SHARMA",
          post: "VICE PRESIDENT",
           imgLocation: imgF + "ANIRUDH_SHARMA.jpg",
        },
        {
          name: "AYAN BABU",
          post: "TREASURER",
          imgLocation: imgF + "AYAN_BABU.jpg",
        },
        {
          name: "AVI BATTACHARYA",
          post: "HEAD, CORPORATE COMMUNICATIONS",
          imgLocation: imgF + "AVI_BHATTACHARYA.jpg",
        },
        {
          name: "SESHADRI SHREYANS",
          post: "HEAD, CORPORATE COMMUNICATIONS",
          imgLocation: imgF + "SESHADRI_SHREYANSH_SRINIDHI.jpg",
        },
        {
          name: "DEBADITYA ROY",
          post: "HEAD, OPERATIONS",
          imgLocation: imgF + "DEBADITYA_ROY.png",
        },
        {
          name: "KHUSHI GILL",
          post: "HEAD, OPERATIONS",
          imgLocation: imgF + "KHUSHI_GILL.jpg",
        },
        
        {
          name: "VEDANTH UDAYKUMAR",
          post: "HEAD, ATH",
          imgLocation: imgF + "VEDANTH_KUMAR.png",
        },
        {
          name: "DASARI VENKATA PRASANNA KUMAR",
          post: "HEAD, ATH",
          imgLocation: imgF + "DASARI_VENKATA_PRASANNA_KUMAR.jpg",
        },
        {
          name: "MANYA MRIDUL",
          post: "HEAD, PUBLICITY",
          imgLocation: imgF + "MANYA_MRIDUL.jpg",
        },
        {
          name: "AMBEDKAR KUMAR",
          post: "HEAD, WDCT",
          imgLocation: imgF + "AMBEDKAR_KUMAR.jpg",
        },
        {
          name: "MASUM AHMAD",
          post: "HEAD, WDCT",
          imgLocation: imgF + "MASUM_AHMAD_RAZA.jpg",
        },
        {
          name: "DNYANESH PATIL",
          post: "HEAD, PUBLICATIONS",
          imgLocation: imgF + "DNYANESH_PATIL.jpg",
        },
        {
          name: "DIP GHOSH",
          post: "HEAD, E-CELL",
          imgLocation: imgF + "DIP_GHOSH.jpg",
        },
        {
          name: "PUNIT KUMAR",
          post: "HEAD, E-CELL",
          imgLocation: imgF + "PUNEET_KUMAR.jpg",
        },
        {
          name: "DURBA SINHA",
          post: "HEAD, RnD CELL",
          imgLocation: imgF + "DURBA_SINHA.jpg",
        },
        { 
          name: "SAKSHI YADAV",
          post: "HEAD, RnD CELL",
          imgLocation: imgF + "SAKSHI_YADAV.jpg",
        },
        {
          name: "AANYA_SHIVAM",
          post: "HEAD, ROBOCELL",
          imgLocation: imgF + "AANYA_SHIVAM.jpg",
        },
        {
          name: "SAYAN MONDAL",
          post: "HEAD, ROBOCELL",
          imgLocation: imgF + "SAYAN_MONDAL.jpg",
        },
        
        {
          name: "VARSHITA YADLAPALLI",
          post: "HEAD, PUBLICITY",
          imgLocation: imgF + "VARSHITHA_YADLAPALI.png",
        },
        {
          name: "SUBHOJIT DUTTA",
          post: "ROBOCON COORDINATOR",
          imgLocation: imgF + "SUBHAJIT_DUTTA.png",
        },
        {
          name: "AVIRAJ CHAKRABORTY",
          post: "ROBOCON COORDINATOR",
          imgLocation: imgF + "AVIRAJ_CHAKRABORTY.jpg",
        },
        {
          name: "SUBHA SARKAR",
          post: "ROBOCON COORDINATOR",
          imgLocation: imgF + "SUBHA_SARKAR.jpg",
        },
        {
          name: "AABHA SINGH",
          post: "DEPUTY TREASURER",
          imgLocation: imgPF + "AABHA_SINGH.jpg",
        },
        {
          name: "ROHIT KUMAR",
          post: "INCUBATION COORDINATOR",
          imgLocation: imgF + "ROHIT_KUMAR.jpg",    
        },
        {
          name: "SANIKOMMU VITAL REDDY",
          post: "INNOVATION HEAD",
          imgLocation: imgF + "SANIKOMMU_VITAL_REDDY.jpg",
        },
        {
          name: "AASHIRYA CHANDAKA",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "AASHIRYA_CHANDAKA.png",
        },
        {
          name: "ABHISHEK RAJ",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "ABHISHEK_RAJ.jpg",
        },
         {
          name: "ABHILASH MAMIDI",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "ABHILASH_MAMIDI.jpg",
        },
        {
          name: "ADITYA KUMAR",
          post: "EXCUTIVE MEMBER",
          imgLocation: imgF + "ADITYA_KUMAR.jpg",
        },
        {           
          name: "AMAN HARKARE",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "AMAN_HARKARE.jpeg",
        },
        {
          name: "ANISHA KUMARI",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "ANISHA_KUMARI.jpg",
        },
        {
          name: "ANGELICA SERENA",
          post: "EXCUTIVE MEMBER",
          imgLocation: imgF + "ANGELICA_SERENA.jpg",
        },
        {
          name: "ASHUTOSH RANJAN",
          post: "EXECUTIVE MEMBER",
          imgLocation: "./img/members/final_year/ASHUTOSH_RANJAN.jpeg",
        },
        {
          name: "AURIC MANDAL",
          post: "EXCUTIVE MEMBER",
          imgLocation: imgF + "AURIC_MANDAL.jpg",
        },
        {           
          name: "AVIRUP DAS",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "AVIRUP_DAS.jpeg",
        },
        {
          name: "BISAKHA SEN",
          post: "EXCUTIVE MEMBER",
          imgLocation: imgF + "BISAKHA_SEN.jpg",
        },
        {
          name: "DEVIYA PALIT",
          post: "EXECUTIVE MEMBER",
          imgLocation: "./img/members/final_year/DEVIYA_PALIT.png",
        },
        {
          name: "DHARMANA ESWAR SAI",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "DHARMANA_ESWAR_SAI.jpg",
        },
        {
          name: "KAUSTAV MAZUMDER",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "KAUSTAV_MAZUMDER.jpg",
        },
        {
          name: "KADARI SUNNY ABHINAND",
          post: "EXECUTIVE MEMBER",
          imgLocation: "./img/members/final_year/KADARI_SUNNY_ABHINAND.png",
        },
        {
          name: "MD.SALMAN ALI",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "MD_SALMAN_ALI.jpg",
        },
        {           
          name: "OBAIDULLAH AZAD",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "OBAIDULLAH_AZAD.png",
        },
        {           
          name: "PAL SHEKHAR",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "PAL_SHEKHAR.jpeg",
        },
        {
          name: "PEEYUSH KUMAR",
          post: "EXCUTUVE MEMBER",
          imgLocation: imgF + "PEEYUSH_KUMAR.jpg",
        },
        {           
          name: "PRASANTHI SANDAKA",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "PRASANTHI_SANDAKA.png",
        },
        {
          name: "PRITAM DAS",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "PRITAM_DAS.jpg",
        }, 
        {
          name: "SAHIL YADAV",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "SAHIL_YADAV.jpg",
        },
        {           
          name: "SOUMYADEEP CHAKRABORTY",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "SOUMYADEEP_CHATERJEE.jpg",
        },
        {
          name: "SRI NIKETH",
          post: "EXECUTIVE MEMBER",
          imgLocation: imgF + "SRI_NIKETH.png",
        },      
        {
          name: "STANZIN TSERING",
          post: "EXECUTIVE MEMBER",
          imgLocation: "./img/members/final_year/STANZIN_TSERING.png",
        },
        {
          name: "TUSSHAR BHAGAT",
          post: "EXECUTIVE MEMBER",
          imgLocation: "./img/members/final_year/TUSSHAR_BHAGAT.png",
        },   
      ],
    };
  }
  createList() {
    var i,
      j,
      k = 0,
      row = [],
      col = [];
    for (i = 0; i < Math.floor(this.state.members.length / 5); i++) {
      col.push(
        <div class="col-sm-2 col-md-offset-1">
          <div class="membercard MemberMembercard">
            <a data-path-hover="M 0,414 275,414 275,240 0,280 z">
              <figure>
                <img
                  src={this.state.members[k].imgLocation}
                  alt=""
                  style={{ width: this.state.imgWidth }}
                />
                <svg viewBox="0 0 275 414" preserveAspectRatio="none">
                  <path d="M 0,414 275,414 275,350 0,350 z" />
                </svg>
                <figcaption>
                  <h1>{this.state.members[k].name}</h1>
                  <p>{this.state.members[k].post}</p>
                </figcaption>
              </figure>
            </a>
          </div>
        </div>
      );
      k++;
      for (j = 0; j < 4; j++) {
        col.push(
          <div class="col-sm-2">
            <div class="membercard MemberMembercard">
              <a data-path-hover="M 0,414 275,414 275,240 0,280 z">
                <figure>
                  <img
                    src={this.state.members[k].imgLocation}
                    alt=""
                    style={{ width: this.state.imgWidth }}
                  />
                  <svg viewBox="0 0 275 414" preserveAspectRatio="none">
                    <path d="M 0,414 275,414 275,350 0,350 z" />
                  </svg>
                  <figcaption>
                    <h1>{this.state.members[k].name}</h1>
                    <p>{this.state.members[k].post}</p>
                  </figcaption>
                </figure>
              </a>
            </div>
          </div>
        );
        k++;
      }
      row.push(<div class="row no-gutter">{col}</div>);
      col = [];
    }

    /* If the number of members is a multiple of 5 then remove this col.push part */
    if (this.state.members.length % 5 !== 0) {
      col.push(
        <div class="col-sm-2 col-md-offset-1">
          <div class="membercard MemberMembercard">
            <a data-path-hover="M 0,414 275,414 275,240 0,280 z">
              <figure>
                <img
                  src={this.state.members[k].imgLocation}
                  alt=""
                  style={{ width: this.state.imgWidth }}
                />
                <svg viewBox="0 0 275 414" preserveAspectRatio="none">
                  <path d="M 0,414 275,414 275,350 0,350 z" />
                </svg>
                <figcaption>
                  <h1>{this.state.members[k].name}</h1>
                  <p>{this.state.members[k].post}</p>
                </figcaption>
              </figure>
            </a>
          </div>
        </div>
      );
    }

    k++;
    for (i = 1; i < this.state.members.length % 5; i++) {
      col.push(
        <div class="col-sm-2">
          <div class="membercard MemberMembercard">
            <a data-path-hover="M 0,414 275,414 275,240 0,280 z">
              <figure>
                <img
                  src={this.state.members[k].imgLocation}
                  alt=""
                  style={{ width: this.state.imgWidth }}
                />
                <svg viewBox="0 0 275 414" preserveAspectRatio="none">
                  <path d="M 0,414 275,414 275,350 0,350 z" />
                </svg>
                <figcaption>
                  <h1>{this.state.members[k].name}</h1>
                  <p>{this.state.members[k].post}</p>
                </figcaption>
              </figure>
            </a>
          </div>
        </div>
      );
      k++;
    }
    row.push(<div class="row no-gutter">{col}</div>);
    col = [];

    return row;
  }

  render() {
    return (
      <div id="team" style={{ display: this.props.disp }}>
        < div class="container my-2" >
          <div class="heading faculty">
            <h1><center>Meet the Faculty Advisors</center></h1>
          </div>
          < div class="container" style={{ textAlign: "center" }}></div>
          <div class="row no-gutter d-flex justify-content-center">


            <div class=" team__container d-flex justify-content-center">

              <div class="membercard MemberMembercard" style={{ margin: '30px' }}>
                <a data-path-hover="M 0,414 275,414 275,240 0,280 z">
                  <figure>
                    <img src="./img/prof/AASHISH_K_BOHRE.png" style={{marginLeft: "auto"}} />
                    <svg viewBox="0 0 275 414" preserveAspectRatio="none">
                      <path d="M 0,414 275,414 275,350 0,350 z" />
                    </svg>
                    <figcaption>
                      <h1 style={{ bottom: "-2px" }}>AASHISH_K_BOHRE</h1>
                      <p>FACULTY ADVISOR</p>
                    </figcaption>
                  </figure>
                </a>
              </div>
              <div class="membercard MemberMembercard" style={{ margin: '30px' }}>
                <a data-path-hover="M 0,414 275,414 275,240 0,280 z">
                  <figure>
                    <img src="./img/prof/HIROK_CHAUDHURI.png" style={{ marginLeft: "auto"}} />
                    <svg viewBox="0 0 275 414" preserveAspectRatio="none">
                      <path d="M 0,414 275,414 275,350 0,350 z" />
                    </svg>
                    <figcaption>
                      <h1 style={{ bottom: "-2px" }}>HIROK_CHAUDHURI</h1>
                      <p>FACULTY ADVISOR</p>
                    </figcaption>
                  </figure>
                </a>
              </div>

              <div class="membercard MemberMembercard" style={{ margin: '30px' }}>
                <a data-path-hover="M 0,414 275,414 275,240 0,280 z">
                  <figure>
                    <img src="./img/prof/PARTHA_S_BOWMIK.png" style={{}} />
                    <svg viewBox="0 0 275 414" preserveAspectRatio="none">
                      <path d="M 0,414 275,414 275,350 0,350 z" />
                    </svg>
                    <figcaption>
                      <h1 style={{ bottom: "-2px" }}>PARTHA_S_BOWMIK</h1>
                      <p>FACULTY ADVISOR</p>
                    </figcaption>
                  </figure>
                </a>
              </div>
{/* 
     <div className="membercard MemberMembercard" style={{ margin: '30px' }}>
      <a data-path-hover="M 0,414 275,414 275,240 0,280 z">
        
        <figure style={{
          position: 'relative',
          width: '100%',
          paddingTop: '133.33%'}} >
          <img 
            src="./img/prof/Aniruddha-Bhattacharya-3.png" 
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center'
            }} 
            alt="DR. ANIRUDDHA BHATTACHARYA"
          />
          <svg viewBox="0 0 275 414" preserveAspectRatio="none"  >
            <path d="M 0,414 275,414 275,350 0,350 z"   />
          </svg>
         
             <figcaption style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
             
             
            color: 'black',
            
          }}>
          
            <h1 style={{   bottom:"-31px" ,marginTop:"0px",marginBottom:"0px"  }}>DR. ANIRUDDHA BHATTACHARYA</h1>
            <p style={{bottom:"-85px"}}>FACULTY ADVISOR</p>
          </figcaption>
        </figure>
      </a>
    </div> */}

    {/* temp */}
     {/* <figure style={{
          position: 'relative',
          width: '100%',
          paddingTop: '133.33%',  
          overflow: 'hidden',
          margin: 0
        }}> */}

                

            </div>

          </div>


          <div class="container" style={{ marginTop: "-120px" }}>
            <div class="heading member">
              <h1 style={{ fontSize: 36 }}>Meet the Team</h1>
            </div>

            {this.createList()}
          </div>


        </div></div>
    );
  }
}
